import { useIntl } from 'react-intl'

function useExperienceSearchLabels() {
  const intl = useIntl()

  return {
    locationLabel: intl.formatMessage({
      id: 'gtD1mY6cZX',
      defaultMessage: 'Where',
      description: 'Label for experience search location input',
    }),
    locationPlaceholder: intl.formatMessage({
      id: 'Ewg3EeQvVW',
      defaultMessage: 'Search by destination or experience',
      description: 'Placeholder text for experience search location input',
    }),
    searchButton: intl.formatMessage({
      id: '1C82xhjxA5',
      defaultMessage: 'Search',
      description: 'Button text to submit experience search form',
    }),
  }
}

export default useExperienceSearchLabels
